export default __webpack_public_path__ + "static/media/03.1fced29d.jpg";